import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';

export default function Signup() {
  const [form, setForm] = useState({name:'',email:'',password:'',phone:'',role:'volunteer'});
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const cred = await createUserWithEmailAndPassword(auth, form.email, form.password);
      await updateProfile(cred.user, {displayName: form.name});
      await setDoc(doc(db, 'users', cred.user.uid), {
        name: form.name, email: form.email, phone: form.phone,
        role: form.role, status: 'pending', trust_score: 0,
        rating: 0, reviews_count: 0, approved: false,
        location: '', city: '', state: '', postcode: '', country: '',
        skills: [], bio: '', photo_url: '', id_card_url: '',
        address_proof_url: '', badges: [], completed_requests: 0,
        created_at: serverTimestamp(),
      });
      navigate('/onboarding');
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#F0FDF4,#FEF9C3)',display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
      <div className="card" style={{width:'100%',maxWidth:'480px'}}>
        <div style={{textAlign:'center',marginBottom:'2rem'}}>
          <Link to="/"><div style={{fontSize:'48px',marginBottom:'8px'}}>🏘</div></Link>
          <h1 style={{fontSize:'24px',fontWeight:800}}>Join CommunityBridge</h1>
          <p style={{color:'#6B7280',fontSize:'14px'}}>Create your free account</p>
        </div>
        <div style={{display:'flex',gap:'8px',marginBottom:'1.5rem'}}>
          {[{val:'volunteer',icon:'🤝',label:'Volunteer'},{val:'requester',icon:'🆘',label:'Need Help'},{val:'organizer',icon:'📅',label:'Organizer'}].map(r=>(
            <div key={r.val} onClick={()=>setForm({...form,role:r.val})}
              style={{flex:1,padding:'10px',borderRadius:'12px',textAlign:'center',cursor:'pointer',border:`2px solid ${form.role===r.val?'#16A34A':'#D1D5DB'}`,background:form.role===r.val?'#DCFCE7':'white',transition:'all .2s'}}>
              <div style={{fontSize:'24px'}}>{r.icon}</div>
              <div style={{fontSize:'12px',fontWeight:600,color:form.role===r.val?'#166534':'#374151'}}>{r.label}</div>
            </div>
          ))}
        </div>
        {error && <div className="alert alert-red">{error}</div>}
        <form onSubmit={handleSignup}>
          <div className="form-group"><label>Full Name</label><input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Your full name" required/></div>
          <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="you@example.com" required/></div>
          <div className="form-group"><label>Phone Number</label><input value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder="+60 12 345 6789"/></div>
          <div className="form-group"><label>Password</label><input type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} placeholder="Min 6 characters" required minLength={6}/></div>
          <button type="submit" className="btn btn-primary" style={{width:'100%',padding:'12px',fontSize:'15px',marginTop:'8px',justifyContent:'center'}} disabled={loading}>
            {loading ? 'Creating account...' : '→ Create Account'}
          </button>
        </form>
        <p style={{textAlign:'center',marginTop:'1.5rem',fontSize:'14px',color:'#6B7280'}}>
          Already have an account? <Link to="/login" style={{color:'#16A34A',fontWeight:600}}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
